import { withPagination } from 'shared/table/hoc/withPagination';
import { Usuario } from 'user/models/Usuario';
import { UsersTable, UsersTableProps } from '../UsersTable/UsersTable';
import { Pageable } from 'shared/table/models/Pageable';
import { useDataFetcher } from 'shared/http';
import { useUserService } from 'user/services/useUserService';
import { SearchUsersRequest } from 'user/models/SearchUsersRequest';
import { useEffect, useMemo } from 'react';

const TableWithPagination = withPagination<Usuario, UsersTableProps>(UsersTable);

const DEFAULT_NO_RESULT_MESSAGE =
  'No se encontraron centros de costos que concuerden con los parámetros de la búsqueda';

export const UsersTableWithPagination = ({
  searchParams,
  reloadToken,
  onDelete,
  onEdit,
  onInfo,
  noResultsMessage,
}: {
  searchParams: SearchUsersRequest;
  reloadToken?: number;
  onDelete?: (usuario: Usuario) => void;
  onEdit?: (usuario: Usuario) => void;
  onInfo?: (usuario: Usuario) => void;
  noResultsMessage?: string;
}) => {
  const userService = useUserService();
  const [usuarios, fetchUsuarios] = useDataFetcher<Pageable<Usuario>>();

  const filtrosEstables = useMemo(() => {
    return searchParams;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(searchParams)]);

  useEffect(() => {
    fetchUsuarios(() => userService.getUsers(filtrosEstables));
  }, [userService, fetchUsuarios, filtrosEstables, reloadToken]);

  const onChangePaginationStatus = async (status: {
    pageNumber: number;
    pageSize: number;
  }): Promise<Pageable<Usuario>> => {
    searchParams.page = status.pageNumber;
    searchParams.size = status.pageSize;
    return userService.getUsers(searchParams);
  };

  return (
    <TableWithPagination
      pageableInit={usuarios.data}
      loadingState={usuarios.isLoading}
      dataFetcherFunction={onChangePaginationStatus}
      noResultsMessages={noResultsMessage || DEFAULT_NO_RESULT_MESSAGE}
      onDelete={onDelete}
      onEdit={onEdit}
      onInfo={onInfo}
    ></TableWithPagination>
  );
};
